var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59998 0.599976C0.771548 0.599976 0.0999756 1.27155 0.0999756 2.09998V15.9C0.0999756 16.7284 0.771549 17.4 1.59998 17.4H15.4C16.2284 17.4 16.9 16.7284 16.9 15.9V2.09998C16.9 1.27155 16.2284 0.599976 15.4 0.599976H1.59998ZM4.59998 4.19998C4.10292 4.19998 3.69998 4.60292 3.69998 5.09998C3.69998 5.59703 4.10292 5.99998 4.59997 5.99998H12.4C12.897 5.99998 13.3 5.59703 13.3 5.09998C13.3 4.60292 12.897 4.19998 12.4 4.19998H4.59998ZM3.69998 8.99998C3.69998 8.50292 4.10292 8.09998 4.59998 8.09998H12.4C12.897 8.09998 13.3 8.50292 13.3 8.99998C13.3 9.49703 12.897 9.89997 12.4 9.89997H4.59997C4.10292 9.89997 3.69998 9.49703 3.69998 8.99998ZM4.59998 12C4.10292 12 3.69998 12.4029 3.69998 12.9C3.69998 13.397 4.10292 13.8 4.59998 13.8H9.99998C10.497 13.8 10.9 13.397 10.9 12.9C10.9 12.4029 10.497 12 9.99998 12H4.59998Z",
    fill: "#9CA1AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptIcon);
export default __webpack_public_path__ + "static/media/receipt-icon.3bb0d8fb76b10f911454446b4440e40b.svg";
export { ForwardRef as ReactComponent };